import {initialState as accountInitialState} from './slices/accountSlice';
import {initialState as environmentInitialState} from './slices/environmentSlice';
import {initialState as menuInitialState} from './slices/menuSlice';
import {initialState as snackInitialState} from './slices/snackSlice';

export const initialState = {
  account: accountInitialState,
  environment: environmentInitialState,
  menu: menuInitialState,
  snack: snackInitialState,
};
